import { validate as isUuid } from 'uuid';

import type { EntityReference } from '@littlebird/markdown-utils';

export type SupportedEntityReference = EntityReference & {
  entity: 'routine' | 'chat' | 'meeting';
};

export const isSupportedEntityReference = (
  reference: EntityReference | undefined
): reference is SupportedEntityReference => {
  if (!reference) return false;

  const id = reference.attributes.id ?? '';

  switch (reference.entity) {
    case 'routine':
      return /^[1-9]\d*$/.test(id);
    case 'chat':
    case 'meeting':
      return isUuid(id);
    default:
      return false;
  }
};
